export default "//cdn.scentbird.com/assets/frontbird-site/images/lemons_7ca574.jpg";